var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5205_10806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72533 14.4034C7.32594 14.8191 6.84764 15.1509 6.31842 15.3794C5.7892 15.6079 5.2197 15.7286 4.64328 15.7342C4.06685 15.7399 3.49509 15.6305 2.96146 15.4125C2.42784 15.1945 1.94308 14.8721 1.53558 14.4644C1.12808 14.0567 0.806023 13.5718 0.588271 13.038C0.370519 12.5043 0.261448 11.9324 0.267447 11.356C0.273445 10.7796 0.394391 10.2102 0.623203 9.68108C0.852015 9.15198 1.18409 8.67386 1.59999 8.2747L8.27399 1.60004C9.08856 0.79083 10.1901 0.33667 11.3383 0.33667C12.4865 0.33667 13.5881 0.79083 14.4027 1.60004C15.2122 2.41443 15.6666 3.51607 15.6666 4.66437C15.6666 5.81266 15.2122 6.91431 14.4027 7.7287L7.72533 14.4034Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93604 4.93604L11.0634 11.064",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21667 3.01068C9.46431 2.76294 9.75833 2.56642 10.0819 2.43234C10.4055 2.29826 10.7524 2.22925 11.1027 2.22925C11.453 2.22925 11.7998 2.29826 12.1234 2.43234C12.447 2.56642 12.741 2.76294 12.9887 3.01068",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5205_10806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.3975b14d9e7969d3a849b41d950edce7.svg";
export { ForwardRef as ReactComponent };